<template>
    <div class="footer-layer">
        <div class="footerLayerBg">
            <a class="footerLayerAuthor" href="https://github.com/vinnow98" target="_blank">
                {{ $t('SiteFooter.webpageBy')}}: Evin Woon
            </a>
        </div>
    </div>
</template>

<script setup>

</script>

<style>
@import '../assets/css/sitefooter.css'
</style>